module.exports = __webpack_public_path__ + "static/img/ac-pdk.ccd85ce4.jpg";